<template lang="pug">
  div.exchange-goods-container
    CommonLoadBox(:loaded="loaded")
      template(slot='skeleton')
        .exchange-list-skeleton-area
          RecommendedGoodsSkeleton
      //- 兑换商品面板
      template(slot='module')
        .exchange-goods-panel-area(v-if="list.length > 0")
          ExchangeSelection(
            :exchangeGoodsList="list"
            :bounty="handleExchangeSuccess"
            @exchange="handleExchangeClick"
            :points="points"
            :moduleConfig="moduleConfig"
            @moreClick="handleMoreGoodsClick"
        )

    //- 商品兑换弹窗
    ExchangePopup(
      :visible="exchangePopupVisible"
      :exchangeInfo="currentExchangeInfo"
      :points="points"
      :isShowGroupPayment="isShowGroupPayment"
      :popupSource=0
      @close="handleExchangePopupClose"
      @success="handleExchangeSuccess"
      @showExchangeSuccessPopup="showExchangeSuccessPopup"
      @bounty="$emit('bounty')"
      @earnPoints="handleAnchorModule"
    )

    //- 兑换成功弹窗
    ExchangeSuccessPopup(
      :goodsInfo="goodsInfo"
      :visible="exchangeSuccessPopupVisible"
      @showInfoClick="handleExchangeGoodsInfoClick"
      @close="handleExchangeSuccessPopupClose"
    )
</template>

<script>
import Toast from '@/components/toast';
import CommonLoadBox from '@/components/common-load-box';
import { anchorToEl } from '@/utils/tools';
import ExchangeSuccessPopup from './exchange-success-popup';
import SPM from '../../common/spm';
import { getExchangeGoodsList, anchorToModule } from '../../common/helper';
import ExchangePopup from './exchange-popup.vue';
import ExchangeSelection from './exchange-selection';
import RecommendedGoodsSkeleton from '../cpns-skeleton/recommended-goods-skeleton';
import { welfareGoCoupon } from '../../utils';

export default {
  name: 'RecommendedGoods',
  components: {
    ExchangePopup,
    ExchangeSelection,
    CommonLoadBox,
    RecommendedGoodsSkeleton,
    ExchangeSuccessPopup,
  },
  props: {
    // 奖励金数额
    points: {
      type: Number,
      default: 0,
    },
    // 模块数据
    moduleData: {
      type: Object,
      default: () => { },
    },
    rewardGuidingRules: {
      type: Array,
      default: () => [],
    },
    moduleConfig: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      // 是否加载完成
      loaded: false,
      // 兑换商品列表
      list: [],
      // 是否展示兑换弹窗
      exchangePopupVisible: false,
      // 是否展示积分+现金组合支付
      isShowGroupPayment: false,
      // 当前点击兑换信息
      currentExchangeInfo: {},
      // 兑换成功弹窗
      exchangeSuccessPopupVisible: false,
      // 兑换成功弹窗商品信息
      goodsInfo: {},
      anchorTimer: null,
      guideInfo: {},
    };
  },
  inject: ['titleBarHeight'],
  watch: {
    points() {
      this.fetchExchangeGoodsList();
    },
  },
  created() {
    // 获取兑换商品列表
    this.fetchExchangeGoodsList();
  },
  methods: {
    // 获取兑换商品列表
    async fetchExchangeGoodsList() {
      const { type } = this.moduleData || {};
      const exchangeGoodsList = await getExchangeGoodsList({
        type,
        pageSize: 3,
      });
      if (exchangeGoodsList.length === 0) return;

      this.list = exchangeGoodsList;
      // 隐藏骨架屏
      this.loaded = true;
    },
    // 关闭兑换弹窗
    handleExchangePopupClose() {
      this.exchangePopupVisible = false;
    },
    // 确认兑换成功
    handleExchangeSuccess() {
      this.$emit('bounty');
      this.exchangePopupVisible = false;
    },
    // 兑换商品点击处理
    handleExchangeClick(item) {
      const { amount, salePriceAfterDeduction } = item || {};
      this.currentExchangeInfo = item;

      if (amount <= this.points) {
        this.isShowGroupPayment = false;
        this.exchangePopupVisible = true;
      } else if (salePriceAfterDeduction > 0) {
        this.isShowGroupPayment = true;
        this.exchangePopupVisible = true;
      } else {
        Toast.show('奖励金不足，快去赚币吧');
      }
    },
    // 更多兑换点击
    handleMoreGoodsClick() {
      const titleBarHeight = this.titleBarHeight();
      anchorToEl('welfare_bountyExchange', titleBarHeight + 10);
    },
    // 展示兑换成功弹窗
    showExchangeSuccessPopup(goodsInfo) {
      this.goodsInfo = goodsInfo;
      this.exchangeSuccessPopupVisible = true;
    },
    // 关闭兑换成功弹窗
    handleExchangeSuccessPopupClose() {
      this.exchangeSuccessPopupVisible = false;
    },
    // 兑换商品信息点击
    handleExchangeGoodsInfoClick() {
      this.handleExchangeSuccessPopupClose();
      // TODO: 跳转优惠券页面,需要兼容小程序
      welfareGoCoupon();
      SPM.clickButton({
        buttonName: 'Welfare_skuduihuanpop_chakan',
        businessInfo: {},
      });
    },
    handleAnchorModule(num) {
      this.guideInfo = this.getGuideInfo(num || this.points);
      this.anchorTimer = anchorToModule(this.guideInfo, this.anchorTimer);
    },
    getGuideInfo(num) {
      return this.rewardGuidingRules.find((item) => {
        if (item.maxNumber === -1) {
          return item.minNumber <= num;
        }
        return item.minNumber <= num && num <= item.maxNumber;
      }) || {};
    },
  },
};
</script>

<style lang="less" scoped>
.exchange-goods-container {
  position: relative;
}
</style>
